import { iconBaseProps, type IconProps } from "@/components/ui/icons/icon-base"

export const MenuIcon = ({ size = 22, ...props }: IconProps) => (
  <svg {...iconBaseProps(size, props)} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 6h18M3 12h18M3 18h18" />
  </svg>
)
